/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-12-02 19:29:00
 * Copyright © Leedarson. All rights reserved.
 */
import { EMPTY_FUNCTION } from './constants';
import confirm from './confirm';

const _defaultProps = {
  title: '',
  position: 'ios',
  content: '',
  radioLabel: '',
  confirm: 'OK',
  cancel: '',
  checked: false,
  onChange: EMPTY_FUNCTION,
  onConfirm: EMPTY_FUNCTION,
  onCancel: EMPTY_FUNCTION,
  afterClose: EMPTY_FUNCTION,
};

export default (props) => {
  const finalProps = { ..._defaultProps, ...props };
  return confirm(finalProps);
};
